<form [formGroup]="maForm" *ngIf="maForm" (ngSubmit)="onSubmit()" class="myform">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="5%" fxLayoutAlign="center">
      <div>
        <mat-form-field>
          <mat-label>Gamma (ɣ) &nbsp; value</mat-label>
          <input matInput formControlName="gammaVal" autocomplete="off" hint="blah">
          <mat-error *ngIf="maForm.invalid && maForm.touched">
            <span class="myerror">
              1.0 &lt; ɣ &le; 1.67
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Mach angle</mat-label>
          <input matInput formControlName="maVal" autocomplete="off">
          <mat-error *ngIf="maForm.invalid && maForm.touched">
            <span class="myerror">0 &le; Mach angle &le; 90</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  
    <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="5%" fxLayoutAlign="center" class="sbmtArea">
        <button mat-raised-button type="submit" [disabled]="maForm.invalid">Calculate</button>
    </div>
  </form>
  
  <div fxLayoutAlign="center" *ngIf="maBool">
    <table>
      <tr>
        <td>
            <img src="assets/math/mach_b.svg" alt="">
        </td>
        <td>{{ isenMach() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ppt_b.svg" alt="">
        </td>
        <td> {{ isenp_pt()  | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ttt_b2.svg" alt="">
        </td>
        <td>{{ isenT_Tt() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/aas2.svg" alt="">
        </td>
        <td>{{ isenA_As() | number:'.1-5'}}</td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/paptas_b2.svg" alt="">
        </td>
        <td>{{ isenpA_ptAstar()  | number:'.1-5'  }}</td>
      </tr>
  
      <tr>
        <td>
            <img src="assets/math/cfopt_b3.svg" alt="">
        </td>
        <td>{{isen_cfopt() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
  
        <td>
            <img src="assets/math/rhorhot_b.svg" alt="">
        </td>
        <td>{{ isen_rhot() | number:'.1-5' }}</td>
  
      </tr>
    </table>
  </div>